module.exports = __webpack_public_path__ + "img/girl.6c17ac40.png";